import { CanvasClient, RouteClient } from "@uniformdev/canvas";

import { enhanceComposition } from "./enhancers";

export type UniformClientOptions = {
    projectId: string;
    apiKey: string;
};

export class UniformClient {
    private readonly canvasClient: CanvasClient;
    private readonly routeClient: RouteClient;

    public constructor(private readonly params: UniformClientOptions) {
        this.canvasClient = new CanvasClient({
            projectId: this.params.projectId,
            apiKey: this.params.apiKey
        });
        this.routeClient = new RouteClient({
            projectId: this.params.projectId,
            apiKey: this.params.apiKey
        });
    }

    public async getLiveComposition(path: string, uniformLocale: string) {
        const nodePath = `/${path}`;

        const route = await this.routeClient.getRoute({
            path: nodePath,
            diagnostics: true,
            locale: uniformLocale
        });

        if (route?.type === "composition") {
            return await enhanceComposition(
                route.compositionApiResponse.composition
            );
        }

        const response = await this.canvasClient.getCompositionByNodePath({
            diagnostics: true,
            projectMapNodePath: nodePath,
            locale: uniformLocale
        });
        if (response?.composition) {
            return await enhanceComposition(response.composition);
        }
        throw new Error(
            `Could not find composition for route ${path} with locale ${uniformLocale}`
        );
    }

    public async getLiveCompositionBySlug(slug: string, uniformLocale: string) {
        const response = await this.canvasClient.getCompositionBySlug({
            diagnostics: true,
            slug,
            state: 0,
            locale: uniformLocale
        });
        return await enhanceComposition(response.composition);
    }
}
